import { getType } from 'typesafe-actions';

import { NetworkRequestState } from '@bolteu/redux-session';

import { GlobalAppActions } from 'rdx/actions';

import {
  requestRequestResetPasswordAsyncAction,
  requestSetNewPasswordAsyncAction,
} from './actions';

export interface PasswordState {
  requestState: NetworkRequestState;
  errors?: Error;
}

export const passwordReducer = (
  state: PasswordState = { requestState: NetworkRequestState.unset },
  action: GlobalAppActions,
): PasswordState => {
  switch (action.type) {
    case getType(requestRequestResetPasswordAsyncAction.request):
      return {
        ...state,
        requestState: NetworkRequestState.waiting,
        errors: undefined,
      };
    case getType(requestRequestResetPasswordAsyncAction.success):
      return {
        ...state,
        requestState: NetworkRequestState.success,
        errors: undefined,
      };
    case getType(requestRequestResetPasswordAsyncAction.failure):
      return {
        ...state,
        requestState: NetworkRequestState.failure,
        errors: action.payload,
      };
    case getType(requestSetNewPasswordAsyncAction.request):
      return {
        ...state,
        requestState: NetworkRequestState.waiting,
        errors: undefined,
      };
    case getType(requestSetNewPasswordAsyncAction.success):
      return {
        ...state,
        requestState: NetworkRequestState.success,
        errors: undefined,
      };
    case getType(requestSetNewPasswordAsyncAction.failure):
      return {
        ...state,
        requestState: NetworkRequestState.failure,
        errors: action.payload,
      };
    default:
      return state;
  }
};
